import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const EnvironmentConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/environment",
    component: React.lazy(() => import("./environment")),
  },
];
